export { default as URL } from "./urls";
export const TransactionNotificationComment = "transaction comment";
export const LeaseEventNotificationComment = "lease event comment";
export const PreTransactionNotificationComment = "pre transaction comment";
export const LeaseEvent = "lease event";
export const Transaction = "transaction";
export const TransactionDeleteRequest = "transaction delete request";
export const PreTransactionDeleteRequest = "pre-transaction delete request";
export const TRANSACTION_COMMENT_CHAR_LIMIT = 2000;
export const TRANSACTION_COMMENT_COUNTER_VISIBLE_AT = Math.floor(
  TRANSACTION_COMMENT_CHAR_LIMIT * 0.5
);
export const TRANSACTION_COMMENT_WARNING_AT = Math.floor(
  TRANSACTION_COMMENT_CHAR_LIMIT * 0.8
);